(function () {
  const TEXTAREA_MAX_HEIGHT = 200;

  function resizeTextarea(textarea) {
    textarea.style.height = 'auto';
    textarea.style.height = `${Math.min(textarea.scrollHeight, TEXTAREA_MAX_HEIGHT)}px`;
  }

  function syncTextField(checkbox) {
    const card = checkbox.closest('.td-product-card');
    if (!card) return;

    const field = card.querySelector('.td-product-card__text-field');
    if (!field) return;

    const textarea = field.querySelector('.td-product-card__textarea');
    const isChecked = checkbox.checked;

    field.hidden = !isChecked;
    checkbox.setAttribute('aria-expanded', String(isChecked));

    if (!textarea) return;

    textarea.disabled = !isChecked;
    if (isChecked) resizeTextarea(textarea);
  }

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('.td-product-card__checkbox');
    if (checkbox) syncTextField(checkbox);
  });

  document.addEventListener('input', (event) => {
    if (event.target.classList.contains('td-product-card__textarea')) {
      resizeTextarea(event.target);
    }
  });
})();
